var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QMC;
(function (QMC) {
    var Klient;
    (function (Klient) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Klient.HttpProvider = HttpProvider;
    })(Klient = QMC.Klient || (QMC.Klient = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Klient')
        .config(['$httpProvider', QMC.Klient.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Klient;
    (function (Klient) {
        let KlientService = class KlientService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Client';
            }
            getClientList(page, pagesize, searchString = null) {
                if (searchString !== null && searchString.trim().length === 0) {
                    searchString = null;
                }
                return super.getPagination(this.modulePath, { searchString: searchString, page: page, pageSize: pagesize }, (data) => {
                    return data;
                });
            }
            getClientListByPredefinedSearch(id, page, pagesize, searchString, onlyActive = false, searchProperties = [], sortBy = '', sortDescending = false) {
                if (searchString !== null && searchString.trim().length === 0) {
                    searchString = null;
                }
                return super.getPagination(this.modulePath + '/ByPredefinedSearch/' + id, { searchString, page, pagesize, onlyActive, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getClient(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getClientExtendedMainData(id) {
                return super.getItem('/Client/ExtendedMainData/' + id, {}, (data) => {
                    return data;
                });
            }
            getPredefinedSearches() {
                return super.get('/PredefinedSearch', { objecttype: 140000 }, (data) => {
                    return data;
                });
            }
            getMinimalClientList() {
                return super.get(this.modulePath + '/MinimalList', {}, (data) => {
                    return data.map(x => ({ ...x, objectId: x.id }));
                });
            }
            getClientPersonList(searchString = "", onlyActive = true) {
                return super.get('/Person/Client', { searchString: searchString, onlyActive: onlyActive }, (data) => {
                    return data;
                });
            }
            getEmployeeList(searchString = "", searchId = QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID) {
                return super.get('/Person/Employee', { searchString: searchString, searchId: searchId }, (data) => {
                    return data;
                });
            }
            getAllPersonLists(listSearch = "") {
                return super.get('/PersonList', { listSearch: listSearch }, (data) => {
                    return data;
                });
            }
            getClientAndEmployeeList(searchString = "", onlyActive = true) {
                return super.get('/Person/ClientAndEmployee', { searchString: searchString, onlyActive: onlyActive }, (data) => {
                    return data;
                });
            }
            getPersonListForLegal(searchText = "", onlyActive = true, isForWv = false) {
                return super.get('/Person/Legal', { searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, (data) => {
                    return data;
                });
            }
            getPersonListByObjectType(objectType, searchText = "", onlyActive = true, isForWv = false) {
                return super.get('/Person/ByObjectType', { objectType: objectType, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, (data) => {
                    return data;
                });
            }
            getPersonListByObjectTypes(objectTypes, searchText = "", onlyActive = true, isForWv = false) {
                return super.get('/Person/ByObjectTypes', { objectTypes: objectTypes, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, (data) => {
                    return data;
                });
            }
            getPersonsByKeyAssignment(key, addEmptyItem = false) {
                return super.getItem("/Person/PeopleSelectionAssignment/" + key, { addEmptyItem: addEmptyItem }, (data) => {
                    return data;
                });
            }
            getContactPersonListOfPerson(parentObjectId, searchText = "", onlyActive = true, isForWv = false, addEmptyItem = false) {
                return super.get('/Person/ContactPersonOfPerson', { parentObjectId: parentObjectId, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv, addEmptyItem: addEmptyItem }, (data) => {
                    return data;
                });
            }
            getLegalGuardianList(searchText = "", onlyActive = true, isForWv = false) {
                return super.get('/Person/LegalGuardianList', { searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, (data) => {
                    return data;
                });
            }
            getAllAddresses() {
                return super.get('/Stammdaten/Address', {}, (data) => {
                    return data;
                });
            }
            createClient(data) {
                return super.post(this.modulePath, data);
            }
            putClient(id, data) {
                return super.put(this.modulePath + '/' + id, data).then((data) => {
                    return data;
                });
            }
            getClientRequiredFields() {
                return super.getItem(this.modulePath + '/RequiredFields');
            }
            putClientExtendedMainData(id, data) {
                return super.put('/Client/ExtendedMainData/' + id, data).then((data) => {
                    return data;
                });
            }
            getClientWv() {
                return super.getItem('/Client/WvModel', {}, (data) => {
                    return data;
                });
            }
            getUserList(addEmptyItem = false) {
                return super.get('/Person/User', { addEmptyItem: addEmptyItem }, (data) => {
                    return data;
                });
            }
            /***** Fls Group *****/
            getFlsGroupList(page, pageSize) {
                return super.get('/Fachleistung/Group', { page: page, pageSize: pageSize }, (data) => {
                    return data;
                });
            }
            getFlsGroupDetail(id) {
                return super.getItem('/Fachleistung/Group/' + id, {}, (data) => {
                    return data;
                });
            }
            /***** misc *****/
            getUpcomingBithdays(dateFrom, dateTo, daysToPast, daysToFuture, organization, subOrganization) {
                return super.get('/Person/Birthdays', { dateFrom, dateTo, daysToPast, daysToFuture, organization, subOrganization }, (data) => {
                    return data;
                });
            }
        };
        KlientService = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Klient', 'KlientService')
        ], KlientService);
        Klient.KlientService = KlientService;
    })(Klient = QMC.Klient || (QMC.Klient = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Klient/qmc.klient.js.map
